// @ts-nocheck

export default {
  SET_EXTERNAL_REQUEST (state, values) {
    state.externalRequest = values
  }
}
